import styled from 'styled-components';

export default styled.div`
  position: relative;
  bottom: 36px;
  margin: 0 20px;
`;
